import { render, staticRenderFns } from "./YbtPayOrderCopy.vue?vue&type=template&id=480d16fe&scoped=true"
import script from "./YbtPayOrderCopy.vue?vue&type=script&lang=js"
export * from "./YbtPayOrderCopy.vue?vue&type=script&lang=js"
import style0 from "./YbtPayOrderCopy.vue?vue&type=style&index=0&id=480d16fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d16fe",
  null
  
)

export default component.exports